import Machinery from '@/models/Machinery'
import User, { hasRole, Role } from '@/models/User'

export default class MachineryPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, machinery: Machinery) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === machinery.entry.catalog.company.id
			case Role.AUDITOR:
				return user.auditor?.id === machinery.entry.catalog.auditor?.id
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, machinery: Machinery) {
		return hasRole(user, Role.USER) && user.company?.id === machinery.entry.catalog.company.id
	}

	restore(user: User, machinery: Machinery) {
		return hasRole(user, Role.USER) && user.company?.id === machinery.entry.catalog.company.id
	}

	delete(user: User, machinery: Machinery) {
		return hasRole(user, Role.USER) && user.company?.id === machinery.entry.catalog.company.id
	}

	forceDelete(_user: User, _machinery: Machinery) {
		return false
	}
}
